import { DisableClickContext } from '~/contexts/DisableClickContext/DisableClickContext';
import GA from '~/services/GA/GA';
import { isNonEmpty } from '~/utils/fnUtil/fnUtil';
import { get, isFunction } from 'lodash';
import PropTypes from 'prop-types';
import { identity, omit } from 'ramda';
import React, { PureComponent } from 'react';
import styled, { ThemeProvider } from 'styled-components';

class Button extends PureComponent {
  static contextType = DisableClickContext;
  static propTypes = {
    className: PropTypes.string,
    children: PropTypes.any,
    styles: PropTypes.string,
    focus: PropTypes.bool,
    onClick: PropTypes.func,
    ga: PropTypes.object,
  };

  static defaultProps = {
    children: null,
    styles: 'normal',
    focus: false,
    onClick: identity,
    ga: null,
  };

  componentDidMount() {
    if (this.props.focus) {
      this.node.focus();
    }
  }

  setRef = (node) => {
    this.node = node;
    if (isFunction(this.props.innerRef)) {
      this.props.innerRef(node);
    }
  };

  getTheme = () =>
    ({
      normal: {},
      action: {
        bgc: '#4757c4',
        minWidth: '56px',
        minHeight: '28px',
        padding: '0 8px',
      },
      cancel: {
        bgc: '#f9f9f9',
        border: '1px solid #ddd',
        color: '#333',
        minWidth: '56px',
        minHeight: '28px',
        padding: '0 8px',
        outline: 'none',
      },
      noStyle: {
        color: 'inherit',
        bgc: 'transparent',
        minHeight: 'initial',
        outline: 'none !important',
      },
    }[this.props.styles]);

  handleClick = (e) => {
    this.props.onClick(e);
    if (isNonEmpty(this.props.ga)) {
      GA.writeClick(this.props.ga);
    }
  };

  render() {
    const props = omit(['onClick', 'innerRef'], this.props);

    const { children } = this.props;
    return (
      <ThemeProvider theme={this.getTheme()}>
        <StyledButton
          onClick={this.context.disabled ? null : this.handleClick}
          {...props}
          ref={this.setRef}
          disabled={props.disabled || this.context.disabled}
        >
          {children}
        </StyledButton>
      </ThemeProvider>
    );
  }
}

const StyledButton = styled.button`
  font-weight: inherit;
  font-size: inherit;
  color: inherit;
  align-items: center;
  background-color: ${(props) => get(props, 'theme.bgc', '#aaa')};
  border: ${(props) => get(props, 'theme.border', '0')};
  border-radius: 2px;
  font-weight: ${({ styles }) => styles === 'action' && 'bold'};
  color: ${(props) => get(props, 'theme.color', '#fff')};
  display: ${(props) => (props.widthAuto ? 'inline-flex' : 'flex')};
  justify-content: ${(props) => (props.align === 'left' ? 'flex-start' : 'center')};
  text-align: ${(props) => props.align === 'left' && 'left'};
  min-height: ${(props) => get(props, 'theme.minHeight', '32px')};
  height: ${(props) => (props.heightAuto ? 'auto' : '100%')};
  width: ${(props) => (props.widthAuto ? 'auto' : '100%')};
  max-width: ${(props) => (props.widthAuto ? 'auto' : '100%')};
  min-width: ${(props) => get(props, 'theme.minWidth', 'initial')};
  cursor: ${(props) => (props.onClick && !props.disabled ? 'pointer' : 'default')};
  padding: ${(props) => get(props, 'theme.padding', '0')};
  outline: ${(props) => get(props, 'theme.outline')};

  &[disabled] {
    color: ${({ styles }) => (styles === 'action' ? 'rgba(255, 255, 255, 0.3)' : '#aaa')};
  }
`;

export default Button;
